const config = {
    globalStartHour: 7,
    globalEndHour: 21,
    globalMinimumTimeSlot: 4,
    globalMaximunTimeCabinSlot: 2,
    globalTimeCabinSlot: 0.5,

    globalBgColors: ["#FFEBEE", "#E3F2FD", "#E8F5E9", "#FFF3E0", "#F3E5F5"],

    globalLogo: '/images/logo/logo_coworking_mazarron.png',
    
    globalCover: '/images/cover/cover_cm.jpg',

    globalScrollDiff: 85,

    globalIframeSrc: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1826.958367975015!2d-1.2597845474131562!3d37.56453132880639!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd64a1a806bd55dd%3A0x59ad74e355e1dac8!2sCOWORKING%20Mazarron!5e0!3m2!1ses!2ses!4v1743773217141!5m2!1ses!2ses"
};

export default config;